<template>
  <section>
    <div class="container rel flex-order">
      <div class="row abs">
        <div class="col-1 hidden-sm"></div>
        <div class="col-10">
          <p class="avail-txt" v-show="typeof $props.filter.check_in_on === 'undefined'">Check availability at this location:</p>

          <div class="tabs">
            <div class="tab">
              <button :class="{ active: $props.activeTab === 'filters' }" @click="$emit('toggleTabs', 'filters')">Accommodation on site</button>
              <button :class="{ active: $props.activeTab === 'moreInfo' }" @click="$emit('toggleTabs', 'moreInfo')">More park info</button>
            </div>

            <div :class="{'tab-open': $props.activeTab === 'filters'|| $props.activeTab === 'mobile'}" id="filters" class="tabcontent">
              <Searchfilter
                :filter="$props.filter"
                :savedFilter="$props.savedFilter"
                :getData="$props.getData"
                :formatActiveFilters="formatActiveFilters"
                :pushSavedFilter="pushSavedFilter"
                :track="$props.track"
                :isMobile="$props.isMobile"
                @track="$props.track"
              />
            </div>
          </div>
        </div>
      </div>

      <div :class="{'tab-open': ($props.activeTab === 'moreInfo' || $props.activeTab === 'mobile')}" id="moreInfo" class="tabcontent more">
        <MoreInfo
          :park="$props.park"
          :map="$props.map"
          :isMobile="$props.isMobile"
          :activeTab="$props.activeTab"
        />
      </div>

      <div class="tabcontent" :class="{'tab-open': $props.activeTab === 'filters' || $props.activeTab === 'mobile' }">
        <div class="container">
          <div class="row">
            <div class="col-1 hidden-sm"></div>
            <div class="col-10">
                <div class="cont lower">
                  <div v-if="activeFilter.length" class="active-filter">Results filtered by: <span>{{ strFilter }} <span @click="clearAllFilters()" class="cross">&#x2715;</span></span></div>
                  <ul class="list" :class="{'no-results': $props.properties.length === 0, 'skeleton': $props.loading}">
                    <Card
                            v-for="property in $props.properties"
                            :key="property.id"
                            :property.sync="property"
                            :clName="'lodge'"
                            :card="'card white'"
                            :loading="$props.loading"
                            :date.sync="$props.filter.check_in_on"
                            :nights.sync="$props.filter.minimum_nights"
                            @track="$props.trackEv"
                    />
                    <div v-if="$props.properties.length === 0 && !$props.requestError" class="msg">
                      <h3 class="sub">No results</h3>
                      <p class="txt ">Try adjusting your search. Here are some ideas:</p>
                      <ul class="pnts">
                        <li class="txt">Change your filters</li>
                        <li class="txt">Change check-in to Friday or Saturday</li>
                      </ul>
                    </div>

                    <div v-else-if="$props.requestError" class="msg">
                      <h3 class="sub">Sorry we couldn't load properties</h3>
                      <p class="txt error">Our site has encountered an error processing this request. Please reload the page and try again.</p>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </section>
</template>

<script>
import Searchfilter from '../shared/filter.vue'
import MoreInfo from '../comp_lodges/moreInfo.vue'
import Card from '../shared/card.vue'

export default {
  data: function () {
    return {
      activeFilter: [],
      strFilter: ''
    }
  },
  props: {
      filter: Object,
      savedFilter: Object,
      tabs: Array,
      loading: Boolean,
      properties: Array,
      track: Function,
      getData: Function,
      count: Number,
      park: Object,
      activeTab: String,
      isMobile: Boolean,
      hasBeenResized: Boolean,
      requestError: Boolean,
      map: {
          type: Object,
          required: true
      }
  },
  components: {
      Searchfilter, MoreInfo, Card
  },
  watch: {
      '$props.activeTab': function(newVal, oldVal) {
          let doc = document,
              sliders = [],
              app = this;

          if (newVal !== oldVal && app.$props.hasBeenResized) {
              setTimeout(function() {
                  sliders = doc.querySelectorAll(".slider");
                  for (let i = 0; i < sliders.length; i++) {
                      sliders[i].slide.setup();
                  }
              }, 100);
              app.$emit('removeResizeFlag');
          }
      }
  },
  methods: {
    formatActiveFilters: function() {
      let obj = {};
      let arr = [];
      obj.apartment = this.filter.apartment;
      obj.cottage = this.filter.cottage;
      obj.garden = this.filter.garden;
      obj.hot_tub = this.filter.hot_tub;
      obj.lodge = this.filter.lodge;
      obj.pets = this.filter.pets;
      obj.caravan = this.filter.caravan; 
      obj.swimming_pool = this.filter.swimming_pool;
      obj.wifi = this.filter.wifi;

      const identifiers = Object.keys(obj);
      let active = identifiers.filter(function(id) {
        return obj[id];
      })

      active.forEach(item => {
        item = item.replace(/_/g, " ");
        arr.push(item);
      });

      this.activeFilter = arr;
      this.strFilter = arr.join(', ');
    },

    clearAllFilters: function() {
      this.filter.apartment = false;
      this.filter.cottage = false;
      this.filter.garden = false;
      this.filter.hot_tub = false;
      this.filter.lodge = false;
      this.filter.apartment = false;
      this.filter.cottage = false;
      this.filter.pets = false;
      this.filter.swimming_pool = false;
      this.filter.wifi = false;
      this.filter.caravan = false; 
      this.activeFilter = [];
      this.strFilter = '';
      this.$props.getData();
    },

    pushSavedFilter: function() {
        let app = this;
        app.filter = JSON.parse(JSON.stringify(app.$props.savedFilter));
    }
  },
  mounted: function () {
    let app = this;
    app.formatActiveFilters();
  }
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';
$easeOutBack: cubic-bezier(0.175, 0.885, 0.320, 1.275);
$duration: .2s;

.tabcontent {
  position: absolute;
  height:0;
  overflow: hidden;
  visibility: hidden;

  &.tab-open {
    position: relative;
    height:initial;
    overflow: initial;
    visibility: visible;
  }
}

.avail-txt {
  padding: .625rem 1.25rem 1.25rem;
  font-weight: 700;
  font-size: .875rem;
}

.tabs {
  background: white;
  margin: 0 0 1rem 0;
  width: 100%;
  box-shadow: 0 .125rem .25rem #ccc;
}

.tab {
  overflow: hidden;
  border-bottom: .063rem solid #ebebeb;
  padding: .625rem .625rem 0;
  display: none;

  button {
    float: left;
    border: none;
    cursor: pointer;
    padding: 1rem;
    font-size: .875rem;
    font-weight: 700;
    outline: none;
    margin: 0 .313rem;
    box-sizing: border-box;
    position: relative;
    background: none;

    &:before,
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: .313rem;
      background-color: $col_primary;
    }

    &:before {
      opacity: 0;
      transform: translateY(- 1rem);
      transition: transform 0s $easeOutBack, opacity 0s;
    }

    &:after {
      opacity: 0;
      transform: translateY(0.5rem);
      transition: transform $duration $easeOutBack, opacity $duration;
    }

    &:hover,
    &:focus,
    &.active {
      &:before,
      &:after {
        opacity: 1;
        transform: translateY(0);
      }

      &:before {
        transition: transform $duration $easeOutBack, opacity $duration;
      }

      &:after {
        transition: transform 0s $duration $easeOutBack, opacity 0s $duration;
      }
    }
  }
}

.search {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.cont {
  width: 100%;
}

.list {
  list-style: none;
  -webkit-overflow-scrolling: touch;
  margin: 0 auto;
  box-sizing: border-box;
  row-gap: 1.25rem;
  -webkit-column-gap: 1.25rem;
  -moz-column-gap: 1.25rem;
  column-gap: 1.25rem;

  &:after {
    flex: auto;
    content: "";
    min-width: 18.75rem;
  }

  &.no-results {
    display: block;
  }
}

.lodge {
  width: 100%;
  box-sizing: border-box;
  padding: 0 1rem;

  .isIE & {
    width: 100%;
    margin-bottom: 1.25rem;
  }
}

.msg {
  height: auto;
  overflow: auto;
  box-sizing: border-box;
  width: 100%;
  border: 0.063rem solid #e1e1e1;
  background-color: #F6F6F6;
  padding: 1.25rem;
}

.sub {
  font-size: 1.8rem;
  color: $col_primary;
}

.txt.error {
  padding: 1rem 0;
}

.pnts {
  list-style: disc;
  padding-left: 1.25rem;
}

.active-filter {
  padding: .625rem 1.25rem 1.25rem;

  &, span {
    font-size: .875rem;
  }

  span {
    font-weight: 700;

    &.cross {
      font-weight: 400;
      padding-left: 1rem;
      cursor: pointer;
      color: $col_deepgrey;
    }
  }
}

.flex-order {
  display: flex;
  flex-direction: column;
}

.tabcontent {
  &.more {
    order: 1;
  }

  order: 3;
}

.row.abs {
  order: 2;
}

@supports (display: grid) {
  .list {
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: 100%;
    grid-template-columns: repeat(1, 100%);
  }

  li.lodge {
    width: unset;
    box-sizing: unset;
    padding: unset;
  }
}

@media #{$xl-phone} {
  .list {
    -ms-grid-columns: 50%;
    grid-template-columns: repeat(2, calc(50% - .625rem));
  }

  .lodge {
    box-sizing: border-box;
    padding: 0 1rem;

    .isIE & {
      float: left;
      width: 50%;
    }
  }
}

@media #{$desktop} {
  .head {
    font-size: 1.75rem;
  }

  .lower {
    margin: 0 1.25rem 0 0;
  }

  .row.abs {
    z-index: 2;
  }

  .container.rel {
    position: relative;
  }

  .list {
    -ms-grid-columns: 33%;
    grid-template-columns: repeat(3, calc(33% - .625rem));
  }

  .lodge {
    box-sizing: border-box;
    padding: 0 1rem;

    .isIE & {
      width: 33%;
    }
  }

  .msg {
    width: 100%;
    max-width: 40rem;
  }

  .tab {
    display: block;
  }

  .flex-order {
    display: block; 
  }
}

</style>